import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';

import TableChartIcon from '@mui/icons-material/TableChart';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

import SUBMISSION_IMG from "../../gpap-lib/img/SUBMIT.png";
import MANAGEMENT_IMG from "../../gpap-lib/img/MANAGE.png";
import EXPERIMENT_IMG from "../../gpap-lib/img/EXPERIMENTS.png";
import FILES_IMG from "../../gpap-lib/img/FILES.png";


const useStyles = makeStyles({
    root: {
        maxWidth: 345,
    },
    cardAction: {
        display: 'block',
        textAlign: 'initial'
    },
    cardMedia:
        {
            background: "#4575B4"
        }
});


function getIcon(title){


    switch (title) {
        case "New Index Case":
            return <NoteAddIcon />;
        case "Import Cases":
            return <CloudUploadIcon />;
        case "New Family Member":
            return <TableChartIcon />;
        case "Browse your cases":
            return <TableChartIcon />

    }

}

function getImage(title){

    let STATIC_URL = window.config.static_files;

    switch (title) {
        case "Manage your data":
            return STATIC_URL += "/img/data_management/MANAGE.png"
        case "Submit Data":
            return STATIC_URL += "/img/data_management/SUBMIT.png"
        case "Submit Experiments":
            return  STATIC_URL +=   "/img/data_management/EXPERIMENTS.png";
        case "Submit Files":
            return STATIC_URL += "/img/data_management/FILES.png"


        default:
            return null

    }


}



export default function StartCard(props) {
    const classes = useStyles();

    let {title, description, href}  = props.item;

    const handleClick = (evt) =>
    {
        window.location.href = href;
    };

    return (
        <Card className={classes.root}>
            <ButtonBase
                className={classes.cardAction}
                onClick={handleClick}>
            <CardActionArea>
                {(getImage(title)!== null) ?
                <CardMedia
                    className={classes.cardMedia}
                    component="img"
                    alt={title}
                    height="140"
                    image={getImage(title)}
                    title={title}
                />
                : null}
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
            </CardActions>
            </ButtonBase>
        </Card>
    );
}
